import { useParams, Link, useNavigate } from 'react-router-dom';
import { grainsData, getGrainById, grainCategoryLabels } from '../data/grainsData';
import { ChevronRight, ChevronDown, Wheat, Globe, Utensils, Package, Award, MessageSquareQuote, Leaf } from 'lucide-react';
import { useState } from 'react';

// AI-Generated grain images
const grainImages = {
  'basmati-1121': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7527556706218bef4e66989a625b238683623d4e466abbc1e1eee0e3576a5400.png',
  'basmati-1718': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/12500227c5d2eac964538ab957c608dfb8b328e5c15b650c344c51d6bb170bfc.png',
  'basmati-1509': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/4cbfdfb95f8bb1fbbecebd117b433721e6c841ef51f787da55d7aafe91649349.png',
  'basmati-1401': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/f8ce34fcef8b881e57fd41df5f158d87ce639fc7fbf5b49b9e91529330c8a512.png',
  'pusa-basmati': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/1d5020d04c70c03606a319dd6fdeb15ceb88fb17ae2a79b64e80012ca8c17bc5.png',
  'sugandha-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/5acefecd047ba22340ae00636dc2f5a2c438c6b30c6ebb9774494934b8196d8b.png',
  'ir64-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3d7f2e24b658c0a7e3e9c613abc69cd4afeaaa9ec80f400002c84c1b0a05f734.png',
  'sona-masoori': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/fd80d42de7a45c99c0aee4bcc694a0ce1c14b8b11c597bb1ad872f80c26a6ff4.png',
  'ponni-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7239f80a614149cda59090ab88108da9c951f1f1e36f5a64ca75534e0d89a564.png',
  'kolam-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/19bb44fd6d2ecf3043f22666ab76f86c1d8da4cc62700c0c7d837ee0482e9d6b.png',
  'swarna-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7b0be470d3dd685caafab1c8024e5bac23ee430ff9df320e612bb632ea66dcf9.png',
  'kalanamak-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/4ba68b458f22e3f1caab85b1360d6b737fad6d6ee0e9582dfd578492b49978b4.png',
  'gobindobhog-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/08252760c8a351151398c42bae5ca4326f1c49331a4fec3c3a2b8d29c5f48798.png',
  'ambemohar-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/48da6f6bb9ad6be9c843cacbc7dd0c1838fa547ad82ef6fb70594824ed118c15.png',
  'joha-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3014c5f2f7ae563799045ce305a7b82705672a4a312ff717d0f9ab97b7afbcf7.png',
  'pokkali-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/07dfeba5cd4c707fedaa14671c07f88119ae97715172ee0cfdc0a84b9df79b51.png',
  'navara-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/0103cd4ef01cb998576856278798be4a9b3e7aa762711e89ac13853fc6ec5582.png',
  'palakkadan-matta': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/a29a375b1d0b2738c4577daf3686c2558351af2091b37b467a93bda7f8d7e02a.png',
  'indrayani-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/be756d01ec681c126c460000508af547e432e19d9c36d097e06091cb1f7ceed3.png',
  'jeerakasala-rice': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/c2fdc30f3fe4df3209c47d716580fe3d23835091c74eab8edaa3fba988e9eea5.png',
  'durum-wheat': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6e4a18aa6469d6f1ce86948d8370b077ff95ff8a14e32e7acf2f9b8ef81fd97f.png',
  'wheat-grain': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/41bf164c4e02badd6da5c077c167dcf89792dc8bfc42514763a056cbff6823be.png',
  'chickpeas-kabuli': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/77c50d94af871cd5345dc52a83e3b999a6015339acd4839d384d8674cce05894.png',
  'chickpeas-desi': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7957362dde0572d84e4d873beac42f56252f0ed000b26404deced5c39e0d2f08.png',
  'red-lentils': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/1129fdee2f0db3c2abd9c5956e3d15347f4cc84ea60acc8848366ee402c10907.png',
  'pigeon-peas': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/dbb4cfc0e39b14f095b71978575815ebc358dd6509c2d7a3854c54644e39b8d4.png',
  'mung-beans': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/07bcee0cc86316352a56848a1c0409e3b41d92c9ec5217ef0af5a6547674b782.png',
  'black-gram': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3781838b1368399c7806ad9d1bad1c501e96d38cf4a094c89a9f19b617a8800c.png',
  'kidney-beans': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7be8e533e11f0bd2540308d7f9696a89c4c94326df68bff2ecea8a343fee258c.png',
  'pearl-millet': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/96ac66ee9e182b68b0310fe414fb3f3318e9b5739862b06a076786c3dcd2d2f1.png',
  'finger-millet': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/fe2a181bf026e9700549e3e2dfb74b1cf33815bdc9de8e2351c560f26c42f7c6.png',
  'sorghum': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/c3e018ef865d04bbd583d0034461eeb663992b07887663f5d71a3ef7ea95b800.png',
  'foxtail-millet': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/78f13f1151880c42bd031eeeb07dfe3eae11dc674d2f5c7dca44e34b63360d18.png',
  'maize-corn': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/045bc757dfe939adad6f951b93e3785a5aa2e7bf25b2d6225fa432a74210fc9e.png',
  'barley': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/391145b2e3eec4d8cfbed55dc6941d67977ccd29989a4317fdf637c82a7ed95a.png',
  'quinoa': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/64e09f010763f6cdae94cd7ecd9c8795970bee8fe9c5a680c5660b05779305ad.png',
};

const getGrainImage = (imageKey) => {
  return grainImages[imageKey] || 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800&h=500&fit=crop';
};

export default function GrainDetail() {
  const { grainId } = useParams();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const grain = getGrainById(grainId);

  if (!grain) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-700 mb-4">Product Not Found</h1>
          <Link to="/products/grains" className="text-[#F47D20] hover:underline">
            Return to Grains Catalogue
          </Link>
        </div>
      </div>
    );
  }

  const handleGrainChange = (newGrainId) => {
    setIsDropdownOpen(false);
    navigate(`/products/grains/${newGrainId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-8 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products/grains" className="hover:text-[#F47D20] transition-colors">Grains</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">{grain.name}</span>
          </nav>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Image */}
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={getGrainImage(grain.image)}
                  alt={grain.name}
                  className="w-full h-64 md:h-80 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1.5 bg-[#F47D20] text-white text-sm font-medium rounded-full">
                  {grainCategoryLabels[grain.category]}
                </div>
              </div>
            </div>

            {/* Title and Quick Info */}
            <div className="w-full lg:w-1/2">
              {/* Grain Dropdown Selector */}
              <div className="relative mb-6">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center justify-between w-full md:w-80 px-4 py-3 bg-white/10 backdrop-blur border border-white/20 rounded-lg text-left hover:bg-white/20 transition-colors"
                  data-testid="grain-dropdown-toggle"
                >
                  <span className="text-sm">Browse Other Products</span>
                  <ChevronDown className={`w-5 h-5 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-full md:w-80 max-h-64 overflow-y-auto bg-white rounded-lg shadow-xl z-50 border border-gray-200">
                    {grainsData.map((g) => (
                      <button
                        key={g.id}
                        onClick={() => handleGrainChange(g.id)}
                        className={`w-full px-4 py-2.5 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between ${
                          g.id === grain.id ? 'bg-[#F47D20]/10 text-[#F47D20]' : 'text-gray-700'
                        }`}
                      >
                        <span>{g.name}</span>
                        {g.id === grain.id && <span className="text-xs">Current</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <h1 className="text-4xl md:text-5xl font-bold mb-2">{grain.name}</h1>
              <p className="text-xl text-gray-300 italic mb-6">{grain.botanicalName}</p>
              
              {/* Quick Info Cards */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Origin</div>
                  <div className="font-semibold text-sm">{grain.origin.split(' - ')[0]}</div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Season</div>
                  <div className="font-semibold text-sm">{grain.season || 'Year-round'}</div>
                </div>
              </div>

              {/* Get Quote Button */}
              <Link
                to={`/contact?product=${encodeURIComponent(grain.name)}&type=Quote%20Request`}
                className="inline-flex items-center px-6 py-3 bg-[#F47D20] text-white font-semibold rounded-lg hover:bg-[#e06d10] transition-colors shadow-lg"
                data-testid="get-quote-btn"
              >
                <MessageSquareQuote className="w-5 h-5 mr-2" />
                Get Quote for {grain.name}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Description */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#263776]/10 rounded-lg flex items-center justify-center">
                  <Wheat className="w-5 h-5 text-[#263776]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Description</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{grain.description}</p>
            </section>

            {/* Characteristics */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#F47D20]/10 rounded-lg flex items-center justify-center">
                  <Leaf className="w-5 h-5 text-[#F47D20]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Characteristics</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{grain.characteristics}</p>
            </section>

            {/* Culinary Uses */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Utensils className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Culinary Uses</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{grain.culinaryUses}</p>
            </section>

            {/* Nutritional Info */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Globe className="w-5 h-5 text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Nutritional Information</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{grain.nutritionalInfo}</p>
            </section>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Specifications */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                  <Package className="w-5 h-5 text-purple-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Specifications</h2>
              </div>
              <div className="space-y-2">
                {Object.entries(grain.specifications).map(([key, value]) => (
                  <div key={key} className="flex justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-500 text-sm capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}</span>
                    <span className="font-medium text-gray-800 text-sm">{value}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* Grades */}
            {grain.grades && (
              <section className="bg-white rounded-xl shadow-sm p-6">
                <h2 className="text-lg font-bold text-[#263776] mb-3">Available Grades</h2>
                <div className="flex flex-wrap gap-2">
                  {grain.grades.map((grade, index) => (
                    <span key={index} className="px-3 py-1 bg-[#263776]/10 text-[#263776] text-sm rounded-full">
                      {grade}
                    </span>
                  ))}
                </div>
              </section>
            )}

            {/* Certifications */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Award className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Certifications</h2>
              </div>
              <p className="text-gray-600 text-sm">{grain.certifications}</p>
            </section>

            {/* Packaging & Shelf Life */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-lg font-bold text-[#263776] mb-3">Packaging</h2>
              <p className="text-gray-600 text-sm mb-4">{grain.packaging}</p>
              <h2 className="text-lg font-bold text-[#263776] mb-3">Shelf Life</h2>
              <p className="text-gray-600 text-sm">{grain.shelfLife}</p>
            </section>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-[#263776] to-[#1e2d5f] rounded-xl p-6 text-white">
              <h3 className="text-lg font-bold mb-3">Interested in {grain.name}?</h3>
              <p className="text-gray-300 text-sm mb-4">
                Get competitive pricing, bulk quantities, and custom specifications for your business needs.
              </p>
              <Link
                to={`/contact?product=${encodeURIComponent(grain.name)}&type=Quote%20Request`}
                className="block w-full py-3 bg-[#F47D20] text-center font-semibold rounded-lg hover:bg-[#e06d10] transition-colors"
                data-testid="sidebar-get-quote-btn"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Related Products */}
      <div className="bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#263776] mb-6">Related Products</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {grainsData
              .filter(g => g.id !== grain.id && g.category === grain.category)
              .slice(0, 6)
              .map((relatedGrain) => (
                <Link
                  key={relatedGrain.id}
                  to={`/products/grains/${relatedGrain.id}`}
                  className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all"
                >
                  <div className="h-24 overflow-hidden">
                    <img
                      src={getGrainImage(relatedGrain.image)}
                      alt={relatedGrain.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="font-medium text-sm text-[#263776] group-hover:text-[#F47D20] transition-colors truncate">
                      {relatedGrain.name}
                    </h3>
                  </div>
                </Link>
              ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/products/grains"
              className="inline-flex items-center px-6 py-3 border-2 border-[#263776] text-[#263776] font-semibold rounded-lg hover:bg-[#263776] hover:text-white transition-colors"
            >
              View Full Catalogue
              <ChevronRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
